var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('van-nav-bar',{attrs:{"title":"联系客服","left-text":"返回","left-arrow":"","onclick":"window.history.go(-1)"}}),_vm._v(" "),_c('iframe',{attrs:{"id":"external-frame","scrolling":"no","marginheight":"0","marginwidth":"0","frameborder":"0","width":"100%","height":_vm.heigh,"src":_vm.server_url}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e88a7a62","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Service.vue
// module id = null
// module chunks = 